// extracted by mini-css-extract-plugin
module.exports = {"box":"index_box_1y_Hc","filterItem":"index_filterItem_x0DPP","label":"index_label_11dAH","value":"index_value_132Rh","btnCol":"index_btnCol_1kZDu","upload":"index_upload_33Meq"};